import dashboard from './dashboard';
import pages from './pages';
import utils from './utils';

// ==============================|| MENU ITEMS ||============================== //

const menuItems = {
  items: [dashboard, pages, utils],
};

export default menuItems;
